import { Button, Center, Divider, Stack, Title } from '@mantine/core';
import { useIsFirstRender } from '@mantine/hooks';
import { IconArrowRight } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { AnimatePresence, motion } from 'motion/react';

import { useAutomationWizardController } from '../controller';

import { AddButton } from './AddButton';
import { ConditionCard } from './ConditionCard';

export const Step3 = () => {
  const { t } = useTranslation();
  const {
    automation,
    navigation: { goToNextStep, isStep3Valid },
  } = useAutomationWizardController();

  const isFirstRender = useIsFirstRender();
  const isLastCondition = (index: number) => index === automation.conditions.length - 1;

  return (
    <Center mt="md">
      <Stack gap={0} align="center">
        <Title order={5} mb="md">
          {t(i18nKeys.AUTOMATION.WIZARD.STEP3.TITLE)}
        </Title>
        <AnimatePresence>
          {automation.conditions.map((_, index) => (
            <motion.div key={index} {...(isFirstRender ? {} : GROW_IN_AND_OUT_ANIMATION_PROPS)}>
              <ConditionCard conditionIndex={index} />
              {!isLastCondition(index) && (
                <Divider my="md" label={t(i18nKeys.AUTOMATION.WIZARD.STEP3.AND_DIVIDER)} />
              )}
            </motion.div>
          ))}
        </AnimatePresence>
        <AddButton />
        <Button
          w="100%"
          mt="lg"
          disabled={!isStep3Valid()}
          rightSection={<IconArrowRight stroke={1.5} size={20} />}
          onClick={goToNextStep}
        >
          {t(i18nKeys.AUTOMATION.WIZARD.STEP3.NEXT)}
        </Button>
      </Stack>
    </Center>
  );
};

export const GROW_IN_AND_OUT_ANIMATION_PROPS = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: 'auto' },
  exit: { opacity: 0, height: 0 },
  transition: { duration: 0.2 },
  style: { overflow: 'hidden', width: '100%' },
};
